import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPolicyReview = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24.056,
	viewBox: "0 0 24 24.056",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "policyReview",
		style: {
			mixBlendMode: "normal",
			isolation: "isolate"
		},
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_7301",
			"data-name": "Group 7301",
			transform: "translate(3.397 2.2)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5702",
					"data-name": "Path 5702",
					d: "M19,12V7.828a2,2,0,0,0-.586-1.414L15.586,3.586A2,2,0,0,0,14.172,3H7A2,2,0,0,0,5,5V19a2,2,0,0,0,2,2h4",
					transform: "translate(-5 -3)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5703",
					"data-name": "Path 5703",
					d: "M8,9h8",
					transform: "translate(-5 -3)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5704",
					"data-name": "Path 5704",
					d: "M8,12h8",
					transform: "translate(-5 -3)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5705",
					"data-name": "Path 5705",
					d: "M8,15h2",
					transform: "translate(-5 -3)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5733",
					"data-name": "Path 5733",
					d: "M14.388,12.4a3.2,3.2,0,0,1,0,4.515,3.164,3.164,0,0,1-4.491,0,3.2,3.2,0,0,1,0-4.515,3.164,3.164,0,0,1,4.491,0",
					transform: "translate(0.358 1.22)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_5734",
					"data-name": "Path 5734",
					d: "M16.326,18.826l-2.8-2.8",
					transform: "translate(1.688 1.97)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_5708",
			"data-name": "Path 5708",
			d: "M0,0H24V24H0Z",
			fill: "none"
		})]
	})
});
export default SvgPolicyReview;
